import {
  CommonProps,
  defaultCommonProps,
} from '../../../../layout/Sidebar/panels/PropertiesView/CommonProperties';
import type { BaseComponentItem } from '../../../../registry/Component.type';

export interface SwitchColumnCaseItem extends BaseComponentItem {
  props: Required<SwitchColumnCase>;
  type: 'SwitchColumnCase';
}

export const defaultValue: Required<SwitchColumnCase> = {
  ...defaultCommonProps,
  case: '',
};

export interface SwitchColumnCase extends CommonProps {
  case?: string;
}
